import {
  AirplaneTiltIcon,
  DeviceMobileIcon,
  SparkleIcon,
  BabyIcon,
  CarIcon,
  PackageIcon,
  CameraIcon,
  GogglesIcon,
  MountainsIcon,
  TentIcon,
  TShirtIcon,
  LaptopIcon,
  WifiHighIcon,
  HeadphonesIcon,
  GameControllerIcon,
  ScissorsIcon,
  BroomIcon,
  LampIcon,
  BabyCarriageIcon,
  BicycleIcon,
  MotorcycleIcon,
  WheelchairIcon,
  VanIcon,
  MicrophoneStageIcon,
  // Level 3
  VideoCameraIcon,
  ApertureIcon,
  CameraRotateIcon,
  DroneIcon,
  ImageIcon,
  SwimmingPoolIcon,
  FishIcon,
  UmbrellaIcon,
  SunglassesIcon,
  PersonSimpleSkiIcon,
  PersonSimpleSnowboardIcon,
  HoodieIcon,
  BackpackIcon,
  DressIcon,
  MaskHappyIcon,
  CrownIcon,
  FlashlightIcon,
  AppleLogoIcon,
  AndroidLogoIcon,
  DeviceTabletIcon,
  DeviceTabletSpeakerIcon,
  MonitorIcon,
  BroadcastIcon,
  SpeakerHighIcon,
  MicrophoneIcon,
  JoystickIcon,
  SteamLogoIcon,
  HairDryerIcon,
  WindIcon,
  SprayBottleIcon,
  DropIcon,
  FlameIcon,
  ScooterIcon,
  PersonSimpleWalkIcon,
  WheelchairMotionIcon,
  JeepIcon,
  type Icon,
} from "@phosphor-icons/react";

/**
 * Phosphor Icons 카테고리 매핑
 * weight="fill" | "duotone" 으로 배경 있는 아이콘 사용 가능
 */
export const categoryPhosphorIcons: Record<string, Icon> = {
  // Level 1
  "10": AirplaneTiltIcon, // 여행·액티비티
  "20": DeviceMobileIcon, // 테크·스마트기기
  "30": SparkleIcon, // 뷰티·홈리빙
  "40": BabyIcon, // 키즈·패밀리
  "50": CarIcon, // 모빌리티

  // Level 2: 여행·액티비티 (10)
  "10-01": CameraIcon, // 카메라·드론
  "10-02": GogglesIcon, // 스노클링·비치
  "10-03": MountainsIcon, // 스키·스노우보드
  "10-04": TentIcon, // 캠핑
  "10-05": TShirtIcon, // 의상·코스튬
  "10-06": MicrophoneStageIcon, // K-pop·공연

  // Level 2: 테크·스마트기기 (20)
  "20-01": DeviceMobileIcon, // 스마트폰
  "20-02": LaptopIcon, // 태블릿·노트북
  "20-03": WifiHighIcon, // 와이파이·공유기
  "20-04": HeadphonesIcon, // 오디오·마이크
  "20-05": GameControllerIcon, // 게임

  // Level 2: 뷰티·홈리빙 (30)
  "30-01": ScissorsIcon, // 뷰티기기
  "30-02": BroomIcon, // 청소
  "30-03": LampIcon, // 생활가전

  // Level 2: 키즈·패밀리 (40)
  "40-01": BabyCarriageIcon, // 유아용품

  // Level 2: 모빌리티 (50)
  "50-01": MotorcycleIcon, // 스쿠터·바이크
  "50-02": WheelchairIcon, // 휠체어·이동보조
  "50-03": CarIcon, // 자동차·캠핑카·미니차량

  // Level 3: 카메라·드론 (10-01)
  "10-01-01": VideoCameraIcon, // 고프로 / 액션캠
  "10-01-02": ApertureIcon, // 360도 카메라 / Insta360
  "10-01-03": CameraRotateIcon, // 오즈모 / 짐벌
  "10-01-04": DroneIcon, // 드론
  "10-01-05": CameraIcon, // 미러리스 / 디지털카메라
  "10-01-06": ImageIcon, // 즉석카메라 (폴라로이드)

  // Level 3: 스노클링·비치 (10-02)
  "10-02-01": SwimmingPoolIcon, // 스노클링 세트
  "10-02-02": FishIcon, // 다이빙 장비
  "10-02-03": UmbrellaIcon, // 비치 텐트 / 그늘막
  "10-02-04": SunglassesIcon, // 비치 액세서리

  // Level 3: 스키·스노우보드 (10-03)
  "10-03-01": PersonSimpleSkiIcon, // 스키 세트
  "10-03-02": PersonSimpleSnowboardIcon, // 스노보드 세트
  "10-03-03": HoodieIcon, // 스키복 / 방한복
  "10-03-04": GogglesIcon, // 고글 / 헬멧

  // Level 3: 캠핑 (10-04)
  "10-04-01": BackpackIcon, // 백패킹 세트
  "10-04-02": TentIcon, // 텐트 세트
  "10-04-03": VanIcon, // 차박 세트

  // Level 3: 의상·코스튬 (10-05)
  "10-05-01": DressIcon, // 전통의상 (한복/기모노 등)
  "10-05-02": MaskHappyIcon, // 코스튬
  "10-05-03": CrownIcon, // 테마 의상

  // Level 3: K-pop·공연 (10-06)
  "10-06-01": FlashlightIcon, // 응원봉

  // Level 3: 스마트폰 (20-01)
  "20-01-01": DeviceMobileIcon, // 삼성 갤럭시
  "20-01-02": AppleLogoIcon, // 아이폰
  "20-01-03": AndroidLogoIcon, // 기타 안드로이드폰

  // Level 3: 태블릿·노트북 (20-02)
  "20-02-01": DeviceTabletIcon, // 아이패드
  "20-02-02": DeviceTabletSpeakerIcon, // 갤럭시 탭
  "20-02-03": LaptopIcon, // 노트북 / 맥북
  "20-02-04": MonitorIcon, // 베이비 모니터

  // Level 3: 와이파이·공유기 (20-03)
  "20-03-01": WifiHighIcon, // 포켓 와이파이
  "20-03-02": BroadcastIcon, // 가정용 공유기

  // Level 3: 오디오·마이크 (20-04)
  "20-04-01": SpeakerHighIcon, // 블루투스 스피커
  "20-04-02": MicrophoneIcon, // 마이크
  "20-04-03": HeadphonesIcon, // 헤드셋 / 이어폰

  // Level 3: 게임 (20-05)
  "20-05-01": GameControllerIcon, // PS5
  "20-05-02": JoystickIcon, // 닌텐도 스위치
  "20-05-03": SteamLogoIcon, // 스팀덱

  // Level 3: 뷰티기기 (30-01)
  "30-01-01": HairDryerIcon, // 드라이기
  "30-01-02": ScissorsIcon, // 고데기 / 스타일러
  "30-01-03": SparkleIcon, // 페이셜 / 뷰티 디바이스

  // Level 3: 청소 (30-02)
  "30-02-01": BroomIcon, // 무선청소기
  "30-02-02": WindIcon, // 다이슨 청소기
  "30-02-03": SprayBottleIcon, // 청소 액세서리

  // Level 3: 생활가전 (30-03)
  "30-03-01": DropIcon, // 가습기
  "30-03-02": LampIcon, // 조명 / 스탠드
  "30-03-03": FlameIcon, // 다리미

  // Level 3: 유아용품 (40-01)
  "40-01-01": BabyCarriageIcon, // 유모차
  "40-01-02": CarIcon, // 카시트
  "40-01-03": BabyIcon, // 아기띠 / 캐리어

  // Level 3: 스쿠터·바이크 (50-01)
  "50-01-01": CarIcon, // 기존 자동차 코드
  "50-03-03": CarIcon, // 자동차
  "50-01-02": MotorcycleIcon, // 오토바이·스쿠터(09-28 통합)
  "50-01-03": BicycleIcon, // 전기자전거 / 자전거
  "50-01-04": ScooterIcon, // 전동 킥보드
  "50-01-05": MotorcycleIcon, // 오토바이

  // Level 3: 휠체어·이동보조 (50-02)
  "50-02-01": WheelchairIcon, // 휠체어
  "50-02-02": PersonSimpleWalkIcon, // 보행 보조기
  "50-02-03": WheelchairMotionIcon, // 전동 휠체어

  // Level 3: 자동차·캠핑카·미니차량 (50-03)
  "50-03-01": VanIcon, // 캠핑카
  "50-03-02": JeepIcon, // 미니차량

  default: PackageIcon,
};

export function getCategoryPhosphorIcon(categoryCode: string): Icon {
  // Exact match first (L1, L2, or L3)
  if (categoryPhosphorIcons[categoryCode]) {
    return categoryPhosphorIcons[categoryCode];
  }
  // L3 ("10-01-01") → try L2 ("10-01") → try L1 ("10")
  const parts = categoryCode.split("-");
  if (parts.length === 3) {
    const l2 = `${parts[0]}-${parts[1]}`;
    if (categoryPhosphorIcons[l2]) return categoryPhosphorIcons[l2];
    if (categoryPhosphorIcons[parts[0]]) return categoryPhosphorIcons[parts[0]];
  } else if (parts.length === 2) {
    if (categoryPhosphorIcons[parts[0]]) return categoryPhosphorIcons[parts[0]];
  }
  return categoryPhosphorIcons.default;
}
